import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

export default new Vuex.Store({
  state: {
    site: [],
    home: [],
    projects: [],
    info: [],
  },
  getters: {
    getProjectByUID: (state) => (uid, collection = state.projects) => {
      let i = collection.length
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i]
        }
      }
    }
  },
  actions: {
    async loadSite ({ commit }) {
      await axios.post('/api/query', {
        "query": "site",
        "select": {
          "title": true,
          "url": true,
        }
      }, {
        auth: {
          username: process.env.VUE_APP_USERNAME,
          password: process.env.VUE_APP_PASSWORD
        }
      }).then(function(response) {
        commit('SET_SITE', response.data.result)
      })
    },
    async loadHome ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('home').slideshow.toFiles",
        "select": {
          "url": true,
          "uid": "file.parent.uid",
          "title": "file.parent.title",
          "num": "file.indexOf",
        }
      }, {
        auth: {
          username: process.env.VUE_APP_USERNAME,
          password: process.env.VUE_APP_PASSWORD
        }
      }).then(function(response) {
        commit('SET_HOME', response.data.result.data)
      })
    },
    async loadProjects ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('projects').children.listed.sortBy('num', 'desc')",
        "select": {
          "title": true,
          "uid": true,
          "number": "page.num",
          "year": true,
          "type": true,
          "location": true,
          "projectstatus": true,
          "surface": true,
          "team": true,
          "description": "page.description.kirbytext",
          "cover": "page.cover.toFile.url",
          "cover_thumb": "page.cover.toFile.resize(200).url",
          "images": {
            "query": "page.images.sortBy('sort')",
            "select": {
              "url": "file.url",
              "thumb": "file.resize(200).url"
            }
          }
        }
      }, {
        auth: {
          username: process.env.VUE_APP_USERNAME,
          password: process.env.VUE_APP_PASSWORD
        }
      }).then(function(response) {
        commit('SET_PROJECTS', response.data.result.data)
      })
    },
    async loadInfo ({ commit }) {
      await axios.post('/api/query', {
        "query": "page('info')",
        "select": {
          "title": true,
          "uid": true,
          "text": "page.text.kirbytext",
          "address": "page.address.kirbytext",
          "contact": "page.contact.kirbytext",
          "credits": "page.credits.kirbytext"
        }
      }, {
        auth: {
          username: process.env.VUE_APP_USERNAME,
          password: process.env.VUE_APP_PASSWORD
        }
      }).then(function(response) {
        commit('SET_INFO', response.data.result)
      })
    }
  },
  mutations: {
    SET_SITE (state, site) {
      state.site = site
    },
    SET_HOME (state, pages) {
      state.home = pages
    },
    SET_PROJECTS (state, pages) {
      state.projects = pages
    },
    SET_INFO (state, pages) {
      state.info = pages
    }
  }
})
